// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__IZn2q","selects":"Documents_selects__2v8No"};